import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { ServiceAccountInput } from '@/models/serviceAccount';

export const updateServiceAccount = async ({ id, data }: { id: string; data: ServiceAccountInput }) => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation UpdateServiceAccount($id: String!, $data: ServiceAccountInputType!) {
        updateServiceAccount(id: $id, data: $data) {
          id
          user
          service
          email
          password
          phoneNumber
          isActive
          isClosed
          isAutomatedAccount
          isManualAccount
          createdAt
          updatedAt
          operatorId
        }
      }
    `),
    variables: {
      id,
      data,
    },
  });

  return response.data?.updateServiceAccount;
};
